export const PagesWithoutAutorization = [
    '/register',
    '/copyrights',
    '/terms'
];

export function isPageWithoutAutorization() {
    return PagesWithoutAutorization.includes(window.location.pathname);
}